export const ar = {
  operator: {
    dialogLabel: 'إعدادات الجلسة',
    eyebrow: 'وضع المشغّل',
    title: 'إعدادات الجلسة',
    close: 'إغلاق',
    language: 'اللغة',
    languageBilingual: 'Français + العربية',
    languageFrench: 'Français',
    languageArabic: 'العربية',
    questionCount: 'عدد الأسئلة في الجلسة',
    shuffleQuestions: 'ترتيب عشوائي للأسئلة',
    shuffleAnswers: 'خلط الإجابات',
    autoAdvance: 'الانتقال التلقائي',
    feedbackDuration: 'مدة عرض النتيجة (ثوانٍ)',
    restartDuration: 'إعادة التشغيل النهائية (ثوانٍ)',
    reset: 'إعادة الضبط',
    apply: 'تطبيق',
    resetShortcut: 'اختصار إعادة الضبط الفورية: Ctrl + Shift + X',
  },
  control: {
    title: 'التحكم عن بعد',
    subtitle: 'اضغط على الإجابة لإرسالها إلى الشاشة',
    connected: 'متصل بالشاشة',
    connecting: 'جارٍ الاتصال…',
    disconnected: 'غير متصل، تحقق من الشبكة',
    error: 'خطأ في الاتصال',
    unconfigured: 'إعداد Pusher غير مكتمل (.env)',
    sent: 'تم الإرسال',
    reset: 'إعادة ضبط الجلسة',
    resetConfirm: 'هل تريد إعادة ضبط الجلسة على الشاشة الرئيسية؟',
  },
} as const;
